import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/Service/auth.service';
import { CompanyService } from 'src/app/Service/company-service.service';
import { EventService } from 'src/app/Service/event.service';
import { Provider } from 'src/app/models/shared/Provider';
import { EnumEnrollType, EnumServicesValidation, EnumStatusGeneric } from 'src/app/models/shared/app-enums';
import { CatEnrollSection } from 'src/app/models/shared/cat-generic';
import { CatStatusGeneric } from 'src/app/models/shared/cat-status-generic';
import { CompanyDetailRp } from 'src/app/models/shared/company';
import { ValidationServices } from 'src/app/models/shared/validation-services';

@Component({
  selector: 'app-detail-company',
  templateUrl: './detail-company.component.html'
})
export class DetailCompanyComponent {
  @Input() childId: string;
  companyEntity: CompanyDetailRp = {};
  fmCompany: FormGroup;
  protected fmTypePerson: FormGroup;
  protected fmSections: FormGroup;
  protected fmServices: FormGroup;
  catStatus: CatStatusGeneric[] = [];
  servicesAllCat: ValidationServices[] = [];
  servicesToCompany: ValidationServices[] = [];


  sectionCat_movil_android: CatEnrollSection[] = [];
  sectionCat_movil_iOS: CatEnrollSection[] = [];
  sectionCat_web: CatEnrollSection[] = [];
  sectionCat_web_responsive: CatEnrollSection[] = [];

  protected showDivUrlINE: boolean = false;
  protected catDocuments: CatStatusGeneric[] = [];

  protected isEnabled: boolean = false;

  /** For managment providers */
  protected catProvidersSections = [
    { id: 1, name: "lblFingerprintCaptureSection" },
    { id: 2, name: "lblOfficialIdCaptureSectionOcr" },
    { id: 3, name: "lblLivenessCheckSection" },
    { id: 4, name: "lblFaceCaptureSection" }
  ];
  protected listProviders: Provider[] = [];

  constructor(
    private _service: CompanyService,
    private _fb: FormBuilder,
    private authService: AuthService,
    private translate: TranslateService,
    protected eventService: EventService,
    private _modalService: NgbModal) {
    this.fmCompany = this._fb.group({
      txtCode: [''],
      txtName: [''],
      txtRFC: [''],
      txtContactName: [''],
      txtContactEmail: [''],
      rbStatusId: [''],
      txtUserId: ['']
    });
    this.fmTypePerson = this._fb.group({
      //IS OK FOR TYPE PERSONS --- IOMC
      //chckbxFPerson: [{value: true, disabled: true}],
      //chckbxMPerson: [''],
      mstLightIdentity: [{value: false, disabled: true}]
    });
    this.fmSections = this._fb.group({
      ddlDocuments: ['']
    });
    this.fmServices = this._fb.group({
      txtUrlINE: ['']
    });
  }

  ngOnInit(): void {
    this.onLoadCat();
    this.onLoadEntity();
  }

  get fmDet() { return this.fmCompany.controls; }
  get fmTypePersonG() { return this.fmTypePerson.controls; }
  get fmSectionsG() { return this.fmSections.controls; }
  get fmServicesG() { return this.fmServices.controls; }

  onLoadEntity() {
    try {
      this.eventService.startLoadingData();

      console.log(this.childId);
      this._service.GetCompanyDetail(this.childId).subscribe({
        next: res => {
          console.log(res);
          this.companyEntity = res.body;
          console.log("GetCompanyDetail=>", this.companyEntity);
          //Llenar formularios
          let statusValue = this.companyEntity.enabled ? EnumStatusGeneric.Active : EnumStatusGeneric.Inactiva;

          this.fmCompany = this._fb.group({
            txtCode: [{ value: this.companyEntity.id, disabled: true }],
            txtName: [{ value: this.companyEntity.name, disabled: true }],
            txtRFC: [{ value: this.companyEntity.rfc, disabled: true }],
            txtContactName: [{ value: this.companyEntity.contactName, disabled: true }],
            txtContactEmail: [{ value: this.companyEntity.contactEmail, disabled: true }],
            rbStatusId: [{ value: statusValue.toString(), disabled: true }],
            txtUserId: [{ value: this.companyEntity.userAdmin, disabled: true }],
          });
          this.fmSections = this._fb.group({
            ddlDocuments: [{ value: this.companyEntity.numDocuments.toString(), disabled: true }]
          });

          //Light identity
          this.isEnabled = this.companyEntity.identity;
          this.fmTypePerson.patchValue({
            mstLightIdentity: this.isEnabled
          });

          //Recorrer el listado de servicios y si viene en la compañía entonces se marca para pintar el check
          this.servicesAllCat.forEach(element => {
            let _service = this.companyEntity.services.findIndex(x => x.serviceId == element.serviceId);
            //Si existe entonces se marca
            if (_service !== -1) {
              let _serviceInCompany = this.companyEntity.services.find(x => x.serviceId == element.serviceId);
              element.checked = _serviceInCompany.enabled;
              this.servicesToCompany.push(element);
            }
          });

          this.companyEntity.sections.forEach(element => {
            if (element.enabled) {
              //Actualizar el check
              if (element.parent == EnumEnrollType.Movil_Android) {
                let _item = this.sectionCat_movil_android.find(x => x.sectionId == element.sectionId);
                _item.checked = true;
              }
              else if (element.parent == EnumEnrollType.Web) {
                let _item = this.sectionCat_web.find(x => x.sectionId == element.sectionId);
                _item.checked = true;
              }
              else if (element.parent == EnumEnrollType.Movil_iOS) {
                let _item = this.sectionCat_movil_iOS.find(x => x.sectionId == element.sectionId);
                _item.checked = true;
              }
              else if (element.parent == EnumEnrollType.Web_responsive) {
                let _item = this.sectionCat_web_responsive.find(x => x.sectionId == element.sectionId);
                _item.checked = true;
              }
            }
          });

          console.log("sectionCat_movil_android", this.sectionCat_movil_android);
          console.log("sectionCat_movil_iOS", this.sectionCat_movil_iOS);
          console.log("sectionCat_web", this.sectionCat_web);
          console.log("sectionCat_web_responsive", this.sectionCat_web_responsive);

          console.log("servicesToCompany", this.servicesToCompany);

          //Buscar si algún servicio del INE está marcado
          let serviceINE = this.servicesToCompany.findIndex(x => x.serviceId == EnumServicesValidation.VERIFICACION_INE_HUELLAS
            || x.serviceId == EnumServicesValidation.VERIFICACION_INE_ROSTRO
            && x.checked);

          console.log("serviceINE", serviceINE);
          if (serviceINE != -1) {
            //The back service, can't get or fount URL INE, then, we set on false always
            //this.showDivUrlINE = true;
          }
          else {
            this.showDivUrlINE = false;
          }

          this.listProviders = this.companyEntity.providers;

          this.eventService.completeLoadingData();
        },
        error: error => {
          console.log(error);
          this.eventService.completeLoadingData();
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
    }
  }

  onClose() {
    this.authService.onValidateCookieUserUI();
    this.catStatus = [];
    this.servicesToCompany = [];
    this.servicesAllCat = [];
    this.companyEntity = {};
    this._modalService.dismissAll();
  }

  onLoadCat() {

    this.catStatus = [
      {
        id: 1,
        name: "Activa",
        value: "1",
        keyLg:"Active"
      },
      {
        id: 0,
        name: "Inactiva",
        value: "0",
        keyLg:"Inactive"
      }
    ];

    this.catStatus.forEach(element => {
      this.translate.stream('common.' + element.keyLg).subscribe((res: string) => {
        element.name = res;
      });
    });

    this._service.GetSectionsList().subscribe({
      next: (response: any) => {
        let _resultado = response.body;
        console.log(response);
        console.log(_resultado);
        //Llenar el listado inicial
        _resultado.forEach(element => {

          if (element.parent == EnumEnrollType.Movil_Android) {
            this.sectionCat_movil_android.push(
              {
                checked: false,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false
              }
            );
          }
          else if (element.parent == EnumEnrollType.Web) {
            this.sectionCat_web.push(
              {
                checked: false,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false
              }
            );
          }
          else if (element.parent == EnumEnrollType.Movil_iOS) {
            this.sectionCat_movil_iOS.push(
              {
                checked: false,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false
              }
            );
          }else if (element.parent == EnumEnrollType.Web_responsive) {
            this.sectionCat_web_responsive.push(
              {
                checked: false,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false
              }
            );
          }
        });
      },
      error: (error: Response) => {
        this.eventService.errorMessage(3, "Ocurrió un error al obtener la información del catálogo.");
        console.log(error);
      }
    });


    this._service.GetServicesList().subscribe({
      next: (response: any) => {
        let _resultado = response.body;
        console.log(response);
        console.log("GetServicesList=>", _resultado);
        //Llenar el listado inicial
        _resultado.forEach(element => {
          this.servicesAllCat.push(
            {
              checked: true,
              description: element.description,
              name: element.name,
              serviceId: element.serviceId
            }
          );

          this.servicesToCompany.push(
            {
              checked: true,
              description: element.description,
              name: element.name,
              serviceId: element.serviceId
            }
          );
        });

        //this.onLoadEntity();
      },
      error: (error: Response) => {
        this.eventService.errorMessage(3, "Ocurrió un error al obtener la información del catálogo.");
        console.log(error);
      }
    });

    this._service.GetSeccionsByCompany(this.childId).subscribe({
      next: (response: any) => {
        let _resultado = response.body;
        console.log(response);
      },
      error: (error: Response) => {
        this.eventService.errorMessage(3, "Ocurrió un error al obtener la información del catálogo.");
        console.log(error);
      }
    });

    this.catDocuments = [
      {
        id: 1,
        name: "1 - 5",
        keyLg: "1_5",
        value: "5"
      },
      {
        id: 0,
        name: "6 - 10",
        keyLg: "6_10",
        value: "10"
      },
      {
        id: 0,
        name: "11 - 15",
        keyLg: "11_15",
        value: "15"
      },
      {
        id: 0,
        name: "Más de 15",
        keyLg: "15_",
        value: "16"
      }
    ];

    this.catDocuments.forEach(element => {
      this.translate.stream('companies.' + element.keyLg).subscribe((res: string) => {
        element.name = res;
      });
    });

  }
}
